import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function useIPhoneBackFixGlobal() {
  const location = useLocation();

  useEffect(() => {
    const isIPhone =
      /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    if (!isIPhone) return;

    const y = window.scrollY;

    const id = requestAnimationFrame(() => {
      window.scrollTo(0, y + 1);

      requestAnimationFrame(() => {
        window.scrollTo(0, y);
      });
    });

    return () => cancelAnimationFrame(id);
  }, [location.key]);
}